import { getPublicTokenHeaders, getStorefrontApiUrl } from '~/utils/shopify-public-client'
import { queryShopifyStorefront } from './shopify-storefront-query'

export const login = async ({
  email,
  password,
}: {
  email: string
  password: string
}) => {
  const query = `
    mutation customerAccessTokenCreate($input: CustomerAccessTokenCreateInput!) {
      customerAccessTokenCreate(input: $input) {
        customerAccessToken {
          accessToken
          expiresAt
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `

  const variables = {
    input: {
      email: email,
      password: password,
    },
  }

  const {
    data: { customerAccessTokenCreate },
  } = await queryShopifyStorefront(query, variables)
  return {
    customerAccessToken:
      customerAccessTokenCreate?.customerAccessToken?.accessToken || '',
  }
}

export const resetPassword = async ({
  resetToken,
  password,
  customerId,
}: {
  resetToken: string
  password: string
  customerId: string
}) => {
  const query = `
    mutation customerReset($id: ID!, $input: CustomerResetInput!) {
      customerReset(id: $id, input: $input) {
        customer {
          id
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `

  const variables = {
    id: customerId,
    input: {
      resetToken: resetToken,
      password: password,
    },
  }

  const {
    data: { customerReset },
  } = await queryShopifyStorefront(query, variables)
  if (customerReset?.customerUserErrors?.length) {
    return {
      error: customerReset.customerUserErrors[0].message,
    };
  }

  return customerReset;
}

export const recoverCustomer = async (email: string) => {
  try {
    const res = await fetch(getStorefrontApiUrl(), {
      headers: getPublicTokenHeaders(),
      method: 'POST',
      cache: 'no-store',
      body: JSON.stringify({
        variables: {
          email: email,
        },
        query: `
          mutation customerRecover($email: String!) {
            customerRecover(email: $email) {
              customerUserErrors {
                code
                field
                message
              }
            }
          }
        `,
      }),
    });

    const data: any = await res.json();
    if (data.errors?.length) {
      return {
        error: data.errors[0].message,
      };
    }
    if (data.data.customerRecover?.customerUserErrors?.length) {
      return {
        error: data.data.customerRecover?.customerUserErrors[0].message,
      };
    }

    return data.data.customerRecover;
  } catch (error) {
    console.warn(error);
    return {
      error: error,
    };
  }
};

export const registerCustomer = async (firstName: string, lastName: string, phone: string, email: string, password: string) => {
  let customer = null;

  try {
    const res = await fetch(getStorefrontApiUrl(), {
      headers: getPublicTokenHeaders(),
      method: 'POST',
      body: JSON.stringify({
        variables: {
          input: {
            email: email,
            password: password,
            firstName: firstName,
            lastName: lastName,
            phone: phone,
          },
        },
        query: `
          mutation createCustomer($input: CustomerCreateInput!) {
            customerCreate(input: $input) {
              customer {
                id
                firstName
                lastName
                displayName
                email
                phone
              }
              customerUserErrors {
                code
                field
                message
              }
            }
          }
        `,
      }),
    });

    const data: any = await res.json();
    if (data?.data?.customerCreate?.customerUserErrors?.length) {
      return {
        error: data?.data?.customerCreate?.customerUserErrors[0].message,
      };
    }

    if (data?.data?.customerCreate == null) {
      if (data?.errors?.length) {
        return {
          error: "Account creation limit exceeded. Please try again later.",
        }
      }
    }

    customer = { ...data.data.customerCreate.customer };
    return customer;
  } catch (error) {
    console.warn(error);
    return {
      error: error,
    };
  }
};


export const activateAccount = async ({
  activationToken,
  password,
  customerId,
}: {
  activationToken: string
  password: string
  customerId: string
}) => {
  const query = `
    mutation customerActivate($id: ID!, $input: CustomerActivateInput!) {
      customerActivate(id: $id, input: $input) {
        customer {
          id
        }
        customerUserErrors {
          code
          field
          message
        }
      }
    }
  `

  const variables = {
    id: customerId,
    input: {
      activationToken,
      password: password,
    },
  }

  const {
    data: { customerActivate },
  } = await queryShopifyStorefront(query, variables)
  if (customerActivate?.customerUserErrors?.length) {
    return {
      error: customerActivate.customerUserErrors[0].message,
    };
  }

  return customerActivate;
}
